var CreateTileData = function (x, y, direction) {
    return { x: x, y: y, direction: direction };
}

export { CreateTileData };